/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
 */
export interface HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType
     */
    description?: string;
}

/**
 * Check if a given object implements the HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType interface.
 */
export function instanceOfHchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType(value: object): value is HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    return true;
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSON(json: any): HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType {
    return HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSONTyped(json, false);
}

export function HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserTypeToJSONTyped(value?: HchbPatientDetailsExternalEhrPatientLeadsInnerWaitlistStatusSetByUserUserType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'type': value['type'],
        'description': value['description'],
    };
}

